import { render, staticRenderFns } from "./StyleBox.vue?vue&type=template&id=9273b75c&scoped=true&"
import script from "./StyleBox.vue?vue&type=script&lang=js&"
export * from "./StyleBox.vue?vue&type=script&lang=js&"
import style0 from "./StyleBox.vue?vue&type=style&index=0&id=9273b75c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9273b75c",
  null
  
)

export default component.exports